import { style } from 'typestyle';
import { TEAL_PRIMARY } from 'src/utils/Style/Theme';

export default {
  container: style({
    $debugName: 'c-lifecycle',
    display: 'flex',
    padding: '0px',
    flex: 1,
    $nest: {
      '.ag-pinned-left-cols-container': {
        marginRight: 20,
      },
    },
  }),

  headersContainer: style({
    $debugName: 'headers',
    height: '100%',
    width: '50%',
    padding: 10,
    $nest: {
      '.ag-row-focus:not(.ag-row-hover)': {
        color: 'black !important',
      },
    },
  }),
  gridClass: style({
    height: '100%',
  }),
  columnsContainer: style({
    $debugName: 'columns',
    width: '50%',
    height: '100%',
    padding: 10,
    $nest: {
      '.ag-row-focus:not(.ag-row-hover)': {
        color: 'black !important',
      },
    },
  }),
  valueText: style({
    color: TEAL_PRIMARY,
  }),
  column: style({
    $debugName: 'column',
    padding: '5px 10px',
    display: 'flex',
    flex: 1,
    flexFlow: 'column',
    textAlign: 'center',
    $nest: {
      '& .left-key': {
        color: '#8c8c8c',
        flex: 1,
        textAlign: 'right',
        padding: '5px',
      },
      '& .right-value': {
        flex: 1,
        textAlign: 'left',
        padding: '5px',
      },
    },
  }),
  uneditable: style({
    color: 'black !important', // need to override grid theme styles
  }),
};
